import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Moment from "react-moment";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";
import Pagination from "../../../../Pagination";

const FormMetadataActivities = ({
  activityLoader,
  tableRef,
  onMouseDown,
  getStudyAuditTrials,
  metadata,
  formActivity,
  formActivityCount,
}) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(formActivityCount / itemsPerPage);
  useEffect(() => {
    getStudyAuditTrials(pageNumber, itemsPerPage);
  }, [metadata, pageNumber, itemsPerPage]);

  useEffect(() => {
    setPageNumber(1);
  }, [metadata]);
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
      >
        {activityLoader ? (
          <PageLoader/>
        ) : formActivity?.length === 0 ? (
          <NoDataFoundTable MSG={"Form activity not found!"} />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th
                    style={{ width: 150 }}
                    onMouseDown={(e) => onMouseDown(e, 1)}
                  >
                    Activity Type
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Activities</th>
                  <th
                    style={{ width: 200 }}
                    onMouseDown={(e) => onMouseDown(e, 3)}
                  >
                    Previous Value
                  </th>
                  <th
                    style={{ width: 200 }}
                    onMouseDown={(e) => onMouseDown(e, 4)}
                  >
                    Current Value
                  </th>
                  <th
                    style={{ width: 100 }}
                    onMouseDown={(e) => onMouseDown(e, 5)}
                  >
                    Activity By
                  </th>
                  <th
                    style={{ width: 130 }}
                    onMouseDown={(e) => onMouseDown(e, 6)}
                  >
                    Activity Date | Time
                  </th>
                </tr>
              </thead>
              <tbody>
                {formActivity?.map((item, index) => (
                  <tr>
                    <td className="text-center">{index + 1 + startIndex}</td>
                    <td className="text-uppercase">{item?.actionType}</td>
                    <td>{item?.activities}</td>
                    <td>{item?.previousValue}</td>
                    <td>{item?.updatedValue}</td>
                    <td>{item?.activityBy}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={formActivityCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default FormMetadataActivities;
